  $(".slick-slider").slick({
   slidesToShow: 4,
   infinite:true,
   slidesToScroll: 4,
   autoplay: false,
   dots:true,
   arrows: false,
     responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ] 
  });


    var slider = jQuery('.bg-carousel');

  function animateSlide(slide) {
    slide.find('h2, img, h6, p').addClass('animate');
  }

  function resetSlide(slide) {
    slide.find('h2, img, h6, p').removeClass('animate');
  }

  // Animate first slide on init
  slider.on('init', function(event, slick) {
    var activeSlide = jQuery(slick.$slides[slick.currentSlide]);
    animateSlide(activeSlide);
  });

  // Reset before changing
  slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    resetSlide(jQuery(slick.$slides[currentSlide]));
  });

  // Animate after change
  slider.on('afterChange', function(event, slick, currentSlide) {
    animateSlide(jQuery(slick.$slides[currentSlide]));
  });

$(".bg-carousel").slick({
   slidesToShow: 1,
   infinite:true,
   slidesToScroll: 1,
   autoplay: false,
   dots:true,
   arrows: false,
   adaptiveHeight: true 
  });
  jQuery('.bg-carousel .slick-slide:first-child h2, .bg-carousel .slick-slide:first-child img, .bg-carousel .slick-slide:first-child h6, .bg-carousel .slick-slide:first-child p').addClass('animate');



function initSlick() {
    var logoList = jQuery('.logo-list');

    if (jQuery(window).width() <= 480) {
      if (!logoList.hasClass('slick-initialized')) {
        logoList.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          autoplay: false,
          dots: true,
          arrows: false
        });
      }
    } else {
      if (logoList.hasClass('slick-initialized')) {
        logoList.slick('unslick');
      }
    }
  }

  initSlick(); // Run on page load

jQuery(window).on('resize', function() {
  initSlick(); // Re-check on resize
});
jQuery(document).ready(function() {

var parentWrapper = jQuery(".footer__block.footer__block--links:nth-child(4) a");

// Add target and rel attributes
parentWrapper.attr("target", "_blank");
parentWrapper.attr("rel", "noopener noreferrer");

  jQuery('shop-the-look-product-list-carousel.shop-the-look__item-carousel.w-full').each(function() {
    var container = jQuery(this);
    container.find('.shop-the-look__item-product').each(function() {
      var productCard = jQuery(this);
      var collectionName = productCard.find('p.product-collection-name');
      var productTitle = productCard.find('a.product-title.h6');
      
      if (collectionName.length && productTitle.length) {
        collectionName.insertBefore(productTitle);
      }
    });
  });


  jQuery('shop-the-look-product-list-carousel.shop-the-look__item-carousel.w-full').each(function() {
    var container = jQuery(this);
    container.find('.shop-the-look__item-product').each(function() {
      var productCard = jQuery(this);
      var collectionName = productCard.find('p.product-collection-name');
      var productTitle = productCard.find('a.product-title.h6');
      
      if (collectionName.length && productTitle.length) {
        collectionName.insertBefore(productTitle);
      }
    });
  });
  
  // For the popover section
  jQuery('shop-the-look-popover.shop-the-look__popover').each(function() {
    var container = jQuery(this);
    container.find('.shop-the-look__item-product').each(function() {
      var productCard = jQuery(this);
      var collectionName = productCard.find('p.product-collection-name');
      var productTitle = productCard.find('.product-card__figure');
      
      if (collectionName.length && productTitle.length) {
        collectionName.insertBefore(productTitle);
      }
    });
  });

  function moveSocialIcons() {
    if (window.matchMedia("(max-width: 767px)").matches) {
      jQuery('ul.footer-ul ul.social-media.social-media--list')
        .insertAfter('.footer__block.footer__block--text');
      jQuery('.template-page .image-with-text--reverse p.h2')
      .insertBefore('.template-page .image-with-text--reverse');  
      jQuery('.template-page .image-with-text:not(.image-with-text--reverse) p.h2')
      .insertBefore('.template-page .image-with-text:not(.image-with-text--reverse)');
    }
  }
  

  
  moveSocialIcons();
  jQuery(window).on('resize', moveSocialIcons);



    var firstAccordion = jQuery('#product-extra-information details').first();

    if (firstAccordion.length) {
        firstAccordion.attr("open", "open");
        firstAccordion.attr("aria-expanded", "true");
    }

});




